import * as z from "zod";

/** Mirrors the `FundingSourceReference` type in @redotech/redo-model/team. */
const fundingSourceReferenceSchema = z.union([
  z.object({ source: z.literal("outbound_labels"), id: z.string() }),
  z.object({
    source: z.literal("general"),
    priority: z.enum(["primary", "secondary", "card"]),
  }),
]);

/**
 * Sets the primary/secondary payment-method selection used for supplies
 * billing (stored at `settings.supplies.activeFundingSources`). The underlying
 * funding-source list is shared with OMS billing; this only updates the
 * supplies-scoped selection.
 */
export const setSuppliesFundingSources = {
  name: "setSuppliesFundingSources" as const,
  input: z.object({
    primary: fundingSourceReferenceSchema.optional(),
    secondary: fundingSourceReferenceSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
